import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';

import { LoginRoutes } from './login';
import { DocumentRoutes } from './document';
import { Main } from 'pages/Main';
import {
  Distribution,
  Scheduling,
  CheckFreights,
  Billing,
  FinancialImpact,
  GhgProtocol,
} from 'pages/ControlTower';
import { SettingsRoutes } from './settings';

const ExternalCronogramaRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(
      'https://app.smartsheet.com/sheets/cxm3c82J49F6rgWM43XWPQ36mChhJp7WmV24cjM1?view=gantt'
    );
  }, []);
  return <></>;
};
export const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <PrivateRoute path="/" exact component={Main} />
        <PrivateRoute path="/base/base" exact component={Main} />
        <PrivateRoute
          path="/control-tower/ghg-protocol"
          exact
          component={GhgProtocol}
        />
        <PrivateRoute
          path="/control-tower/distribution"
          exact
          component={Distribution}
        />
        <PrivateRoute
          path="/control-tower/scheduling"
          exact
          component={Scheduling}
        />
        <PrivateRoute
          path="/control-tower/check-freights"
          exact
          component={CheckFreights}
        />
        <PrivateRoute path="/control-tower/billing" exact component={Billing} />
        <PrivateRoute
          path="/control-tower/financial-impact"
          exact
          component={FinancialImpact}
        />
        <Route
          path="/cronograma"
          exact
          component={ExternalCronogramaRedirect}
        />
      </Switch>
      <LoginRoutes />
      <SettingsRoutes />
      <DocumentRoutes />
    </>
  );
};
